const {Category} = require("@mui/icons-material");

const getCryptoCurrencyListHomeForWatchlist = (data) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "123456xxxxxxxxxxxx");

    var raw = JSON.stringify({
        slug: data.slug,
        start_index: data.start_index,
        limit: data.limit,
        user_id: data.user_id,
        pathname: data.pathname,
    });

    var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
    };

    return fetch(`https://crowdwisdom.live/wp-json/portfolio/v1/cryptoCurrencyListHomeForWatchlist`, requestOptions)
    .then((response) => response.json())
    .catch((error) => console.log("error", error));
};

//login call
const getCryporCurrencyListHome = (data) => {
    // build a simple form-encoded body
    const params = new URLSearchParams();
    params.append("slug", data.slug);
    params.append("start_index", data.start_index);
    params.append("limit", data.limit);
    if (data.category) params.append("category", data.category);
    if (data.buy_sell_hold) params.append("buy_sell_hold", data.buy_sell_hold);
    if (data.selected_risk) params.append("selected_risk", data.selected_risk);
    if (data.hashtagdata) params.append("hashtagdata", data.hashtagdata);
    if (data.selected_filters) params.append("selected_filters", JSON.stringify(data.selected_filters));
    if (data.volume) params.append("volume", JSON.stringify(data.volume));
    if (data.marketCap) params.append("marketCap", JSON.stringify(data.marketCap));
    if (data.sentiment_filters) params.append("sentiment_filters", JSON.stringify(data.sentiment_filters));
    if (data.user_id) params.append("user_id", data.user_id);
    params.append("pathname", data.pathname);
    // move your token into the body (no more custom header!)
    params.append("auth_token", "123456xxxxxxxxxxxx");

    return fetch("https://crowdwisdom.live/wp-json/portfolio/v1/cryptocurrencylisthome", {
        method: "POST",
        body: params, // automatically sets Content‑Type: application/x-www-form-urlencoded;charset=UTF-8
        redirect: "follow",
    })
    .then((res) => res.json())
    .catch((err) => {
        console.error("Fetch error:", err);
        throw err;
    });
};

const getPortfolioWatchlistAPIView = (data) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    var requestOptions = {
        method: "GET",
        headers: myHeaders,
    };

    return fetch(
        `https://crowdwisdom.live/wp-json/portfolio/v1/get_user_watchlist/?user_id=${data.user_id}`,
        requestOptions
    )
    .then((response) => {
        if (!response.ok) {
            throw new Error("Error while fetching data");
        }
        return response.json();
    })
    .catch((error) => {
        console.error("Error:", error);
        return {code: "500", message: "Internal Server Error"};
    });
};

const getCryptoWatchlistAPIView = (data) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", data.token);

    var requestOptions = {
        method: "GET",
        headers: myHeaders,
    };

    return fetch(
        `https://crowdwisdom.live/wp-json/portfolio/v1/get_user_crypto_watchlist/?user_id=${data.user_id}`,
        requestOptions
    )
    .then((response) => {
        if (!response.ok) {
            throw new Error("Error while fetching data");
        }
        return response.json();
    })
    .catch((error) => {
        console.error("Error:", error);
        return {code: "500", message: "Internal Server Error"};
    });
};

const getPortfolioForGallery = (data) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    // Flatten data manually if needed
    const formData = new URLSearchParams();
    formData.append("user_id", data.user_id);
    formData.append("search_text", data.search_text);
    formData.append("date[type]", 1);
    formData.append("date[value]", data.value); // e.g., '2024-04-01'

    formData.append("is_verified", data.is_verified || "no");
    formData.append("sort_by_roi", data.sort_by_roi || "desc");
    formData.append("start_index", data.start_index);
    formData.append("limit", data.limit);
    formData.append("selected_hashtags", data.selected_hashtags); // make sure this is a string
    formData.append("access_check", data.access_check || 0);
    formData.append("pathname", data.pathname);

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formData,
        redirect: "follow",
    };

    return fetch(`https://crowdwisdom.live/wp-json/portfolio/v1/getportfolioforgallery`, requestOptions)
    .then((response) => response.json())
    .catch((error) => {
        console.error("Error:", error);
        return {code: "500", message: "Internal Server Error"};
    });
};

const getIndexPortfolio = (data) => {
    const urlEncodedData = new URLSearchParams();
    urlEncodedData.append("user_id", data.user_id);
    urlEncodedData.append("search_text", data.search_text ? data.search_text : "");
    urlEncodedData.append("start_index", data.start_index ? data.start_index : 0);
    urlEncodedData.append("limit", data.limit);
    urlEncodedData.append("date_change", data.date_change);
    urlEncodedData.append("roi_data", data.roi_data);
    urlEncodedData.append("requested_agent", navigator.userAgent + ":" + data.user_id);

    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        body: urlEncodedData,
        redirect: "follow",
    };

    return fetch(`https://crowdwisdom.live/wp-json/portfolio/v1/get_index_portfolio`, requestOptions)
    .then((response) => response.json())
    .catch((error) => {
        console.error("Error:", error);
        return {code: "500", message: "Internal Server Error"};
    });
};

const getPortfolioForCategoryGallery = (data) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    // Flatten data manually if needed
    const formData = new URLSearchParams();
    formData.append("user_id", data.user_id);
    formData.append("search_text", data.search_text);
    formData.append("date[type]", 1);
    formData.append("date[value]", data.value);
    formData.append("is_verified", data.is_verified || "no");
    formData.append("sort_by_roi", data.sort_by_roi || "desc");
    formData.append("start_index", data.start_index);
    formData.append("limit", data.limit);
    formData.append("categoryName", data.categoryName);

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formData,
        redirect: "follow",
    };

    return fetch(`https://crowdwisdom.live/wp-json/portfolio/v1/getportfolioforcategorygallery`, requestOptions)
    .then((response) => {
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        return response.json();
    })
    .then((result) => {
        return result;
    })
    .catch((error) => {
        console.error("Error:", error);
        return {code: "500", message: "Internal Server Error"};
    });
};

const getPortfolioForGalleryWatchlist = (data) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestBody = {
        user_id: data.user_id,
        search_text: data.search_text,
        date: {
            type: "1",
            value: data.value,
        },
        is_verified: data.is_verified || "no",
        sort_by_roi: data.sort_by_roi || "desc",
        start_index: data.start_index,
        limit: data.limit,
    };

    var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(requestBody),
        redirect: "follow",
    };

    return fetch(`https://crowdwisdom.live/wp-json/portfolio/v1/getportfolioforgallerywatchlist`, requestOptions)
    .then((response) => {
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        return response.json();
    })
    .then((result) => {
        return result;
    })
    .catch((error) => {
        console.error("Error:", error);
        return {code: "500", message: "Internal Server Error"};
    });
};

const getPortfolioForGalleryList = (data) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestBody = {
        user_id: data.user_id,
        search_text: data.search_text,
        portfolioName: data.portfolioName,
        date: {
            type: "1",
            value: data.value,
        },
        is_verified: data.is_verified || "no",
        sort_by_roi: data.sort_by_roi || "desc",
        start_index: data.start_index,
        limit: data.limit,
    };

    var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(requestBody),
        redirect: "follow",
    };

    return fetch(`https://crowdwisdom.live/wp-json/portfolio/v1/getportfolioforgallerylist`, requestOptions)
    .then((response) => {
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        return response.json();
    })
    .then((result) => {
        return result;
    })
    .catch((error) => {
        console.error("Error:", error);
        return {code: "500", message: "Internal Server Error"};
    });
};

const getPortfolioForGallery1 = (data) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestBody = {
        user_id: data.user_id,
        search_text: data.search_text,
        date: {
            type: "1",
            value: data.value,
        },
        is_verified: data.is_verified || "no",
        sort_by_roi: data.sort_by_roi || "desc",
        start_index: data.start_index,
        limit: data.limit,
    };

    var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(requestBody),
        redirect: "follow",
    };

    return fetch(`https://crowdwisdom.live/wp-json/portfolio/v1/getportfolioforgallery1`, requestOptions)
    .then((response) => {
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        return response.json();
    })
    .then((result) => {
        return result;
    })
    .catch((error) => {
        console.error("Error:", error);
        return {code: "500", message: "Internal Server Error"};
    });
};

const getSymbolbyPortfolioid = (data) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", data.Token);

    var requestBody = {
        user_id: data.user_id,
        portfolio_id: data.portfolio_id,
    };

    var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(requestBody),
        redirect: "follow",
    };

    return fetch(`https://crowdwisdom.live/wp-json/portfolio/v1/getsymbolbyportfolioid`, requestOptions)
    .then((response) => {
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        return response.json();
    })
    .then((result) => {
        return result;
    })
    .catch((error) => {
        console.error("Error:", error);
        return {code: "500", message: "Internal Server Error"};
    });
};

const getCryptoPortfolioForGallery = (data) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestBody = {
        user_id: data.user_id,
        search_text: data.search_text,
        date: {
            type: "1",
            value: data.value,
        },
        is_verified: data.is_verified || "no",
        sort_by_roi: data.sort_by_roi || "desc",
        start_index: data.start_index,
        limit: data.limit,
        crypto: data.crypto,
        access_check: data.access_check || 0,
    };

    var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(requestBody),
        redirect: "follow",
    };

    return fetch(`https://crowdwisdom.live/wp-json/portfolio/v1/getCryptoPortfolioForGallery`, requestOptions)
    .then((response) => {
        console.log(response);
        if (response.ok || response.status === 403) {
            return response.json();
        }

        throw new Error("Network response was not ok");
    })
    .then((result) => {
        return result;
    })
    .catch((error) => {
        console.error("Error:", error);
        return {code: "500", message: "Internal Server Error"};
    });
};

const getTopPerformingCryptos = (data) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestBody = {
        user_id: data.user_id,
        value: data.value,
    };

    var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(requestBody),
        redirect: "follow",
    };

    return fetch(`https://crowdwisdom.live/wp-json/portfolio/v1/getTopPerformingCryptos`, requestOptions)
    .then((response) => {
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        return response.json();
    })
    .then((result) => {
        return result;
    })
    .catch((error) => {
        console.error("Error:", error);
        return {code: "500", message: "Internal Server Error"};
    });
};

const getTopPortfolioForGallery = (data) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    // Flatten data manually if needed
    const formData = new URLSearchParams();
    formData.append("user_id", data.user_id);
    formData.append("search_text", data.search_text);
    formData.append("date[type]", 1);
    formData.append("date[value]", data.value); // e.g., '2024-04-01'

    formData.append("is_verified", data.is_verified || "no");
    formData.append("sort_by_roi", data.sort_by_roi || "desc");
    formData.append("start_index", data.start_index);
    formData.append("limit", data.limit);
    formData.append("selected_hashtags", data.selected_hashtags); // make sure this is a string
    formData.append("access_check", data.access_check || 0);
    formData.append("pathname", data.pathname);

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formData,
        redirect: "follow",
    };

    return fetch(`https://crowdwisdom.live/wp-json/portfolio/v1/getTopPortfolioForGallery`, requestOptions)
    .then((response) => response.json())
    .catch((error) => {
        console.error("Error:", error);
        return {code: "500", message: "Internal Server Error"};
    });
};

// Export all functions at once
module.exports = {
    getCryporCurrencyListHome,
    getCryptoCurrencyListHomeForWatchlist,
    getPortfolioForGallery,
    getIndexPortfolio,
    getPortfolioForCategoryGallery,
    getPortfolioForGalleryWatchlist,
    getPortfolioForGalleryList,
    getPortfolioForGallery1,
    getSymbolbyPortfolioid,
    getCryptoPortfolioForGallery,
    getTopPerformingCryptos,
    getPortfolioWatchlistAPIView,
    getCryptoWatchlistAPIView,
    getTopPortfolioForGallery,
};
